export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7219.aed0be65.jpg";